import React from 'react';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Copyright from './common/Copyright';
import Quicklogin from './quicklogin';
import Maintenance from "./maintenance";
import Webinar from "./webinar";
import Anketa from "./anketa";
import Quiz from "./quiz";

export default function App() {
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get('p');

    switch (page) {
        case 'maintenance':
            return (
                <Maintenance/>
            );
        case 'remote':
            return (
                <Webinar/>
            );
        case 'anketa':
            return (
                <Anketa/>
            );
        case 'quiz':
            return (
                <Quiz/>
            );
        case 'quicklogin':
        default:
            return (
                <Quicklogin />
            );
    }

}
